import React, { CSSProperties, FunctionComponent } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { getProViewStatusColor } from 'utils/ui';

const BUTTON_WIDTH = 70;

type ProView = {
  id: number;
  status: string;
  bilikZone: {
    mainCityCode: string;
  };
};

type ZoneButtonProps = {
  proView: ProView;
  style?: CSSProperties;
};

export const ZoneButton: FunctionComponent<ZoneButtonProps> = ({
  proView,
  style,
}) => {
  return (
    <Button
      type="button"
      style={{ width: BUTTON_WIDTH, ...style }}
      basic={true}
      color="grey"
      onClick={(event): void => {
        event.preventDefault();
        event.stopPropagation();
        window.open(`/pros/update/${proView.id}/pro_reviews`, '_blank');
      }}
    >
      <Icon
        name="circle"
        size="small"
        color={getProViewStatusColor(proView.status)}
      />
      {proView.bilikZone.mainCityCode}
    </Button>
  );
};
